module.exports = __webpack_public_path__ + "img/railwayBroadcast1.0.33f6e57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/railwayBroadcast1.0.png
// module id = 6wx9
// module chunks = 0